import React from "react";

/* Animated WattBot mascot — pure SVG/CSS, states: idle | wave | think | happy */
export default function WattBotCharacter({ state = "idle", size = 88, reduced = false }) {
  return (
    <div style={{ width: size, height: size * 1.15 }} aria-hidden="true" className={`wb-char ${reduced ? "wb-reduced" : ""} wb-${state}`}>
      <style>{`
        .wb-char svg { overflow: visible; }
        .wb-char .wb-body { animation: wbFloat 3.4s ease-in-out infinite; transform-origin: 60px 70px; }
        .wb-char .wb-eye { animation: wbBlink 4.5s ease-in-out infinite; transform-origin: center; transform-box: fill-box; }
        .wb-char .wb-bolt { animation: wbBolt 2.8s ease-in-out infinite; }
        .wb-char .wb-tip { animation: wbTip 2s ease-in-out infinite; }
        .wb-char .wb-arm-r { transform-origin: 96px 74px; transform-box: view-box; }
        .wb-wave .wb-arm-r { animation: wbWave 1.1s ease-in-out 2; }
        .wb-think .wb-pupils { animation: wbScan 1.4s ease-in-out infinite; }
        .wb-char .wb-shadow { animation: wbShadow 3.4s ease-in-out infinite; transform-origin: 60px 132px; }
        @keyframes wbFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes wbShadow { 0%,100% { transform: scaleX(1); opacity:.35; } 50% { transform: scaleX(.8); opacity:.22; } }
        @keyframes wbBlink { 0%,44%,52%,100% { transform: scaleY(1); } 48% { transform: scaleY(0.1); } }
        @keyframes wbBolt { 0%,100% { opacity: .85; } 50% { opacity: 1; filter: drop-shadow(0 0 4px #FFC857); } }
        @keyframes wbTip { 0%,100% { opacity: .6; } 50% { opacity: 1; } }
        @keyframes wbWave { 0%,100% { transform: rotate(0deg); } 40% { transform: rotate(-55deg); } 70% { transform: rotate(-30deg); } }
        @keyframes wbScan { 0%,100% { transform: translateX(-2.5px); } 50% { transform: translateX(2.5px); } }
        .wb-reduced .wb-body, .wb-reduced .wb-eye, .wb-reduced .wb-bolt, .wb-reduced .wb-tip,
        .wb-reduced .wb-arm-r, .wb-reduced .wb-pupils, .wb-reduced .wb-shadow { animation: none !important; }
        @media (prefers-reduced-motion: reduce) {
          .wb-char .wb-body, .wb-char .wb-eye, .wb-char .wb-bolt, .wb-char .wb-tip,
          .wb-char .wb-arm-r, .wb-char .wb-pupils, .wb-char .wb-shadow { animation: none !important; }
        }
      `}</style>
      <svg viewBox="0 0 120 140" width="100%" height="100%">
        <defs>
          <linearGradient id="wbBodyG" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#3A4756" />
            <stop offset="1" stopColor="#1C2733" />
          </linearGradient>
          <linearGradient id="wbFaceG" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#0E2233" />
            <stop offset="1" stopColor="#071A2D" />
          </linearGradient>
        </defs>
        <ellipse className="wb-shadow" cx="60" cy="132" rx="26" ry="5" fill="#071A2D" opacity="0.35" />
        <g className="wb-body">
          {/* antenna */}
          <line x1="60" y1="14" x2="60" y2="24" stroke="#8B98A5" strokeWidth="2.5" strokeLinecap="round" />
          <circle className="wb-tip" cx="60" cy="11" r="4" fill="#FFC857" />
          {/* head */}
          <rect x="30" y="24" width="60" height="40" rx="14" fill="url(#wbBodyG)" stroke="#4B5A6A" strokeWidth="1" />
          <rect x="37" y="31" width="46" height="26" rx="10" fill="url(#wbFaceG)" />
          {/* eyes */}
          <g className="wb-pupils">
            <rect className="wb-eye" x="46" y="38" width="8" height="12" rx="4" fill="#00D4FF" />
            <rect className="wb-eye" x="66" y="38" width="8" height="12" rx="4" fill="#00D4FF" />
          </g>
          {/* left arm */}
          <rect x="16" y="72" width="9" height="22" rx="4.5" fill="#2C3947" />
          {/* right arm (waves) */}
          <g className="wb-arm-r">
            <rect x="94" y="70" width="9" height="24" rx="4.5" fill="#2C3947" />
            <circle cx="98.5" cy="94" r="5" fill="#3A4756" />
          </g>
          {/* torso */}
          <rect x="26" y="68" width="68" height="48" rx="18" fill="url(#wbBodyG)" stroke="#4B5A6A" strokeWidth="1" />
          <rect x="38" y="76" width="44" height="30" rx="10" fill="#0A2540" />
          {/* chest bolt */}
          <path className="wb-bolt" d="M63 80 L52 93 h6 l-3 10 L67 90 h-6 z" fill="#FFC857" />
          {/* energy line detail */}
          <path d="M32 112 h56" stroke="#00D4FF" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
          <circle cx="34" cy="98" r="2" fill="#21F59B" opacity="0.8" />
        </g>
      </svg>
    </div>
  );
}
